import { render, staticRenderFns } from "./ContactInfoCard.vue?vue&type=template&id=9bd1415a&"
import script from "./ContactInfoCard.vue?vue&type=script&lang=js&"
export * from "./ContactInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports